enum FloraFeedbackSentiment {
  Positive = 'positive',
  Negative = 'negative',
}

enum FloraFeedbackReason {
  Inaccurate = 'inaccurate',
  Hallucinated = 'hallucinated',
  WrongData = 'wrong_data',
  Incomplete = 'incomplete',
  IgnoredRequest = 'ignored_request',
  Formatting = 'formatting',
  Outdated = 'outdated',
  Other = 'other',
}

const FLORA_FEEDBACK_REASON_OPTIONS: { value: FloraFeedbackReason; label: string }[] = [
  { value: FloraFeedbackReason.Inaccurate, label: 'Incorrect or inaccurate' },
  { value: FloraFeedbackReason.Hallucinated, label: 'Made up data or metrics' },
  { value: FloraFeedbackReason.WrongData, label: 'Pulled the wrong data or used the wrong tool' },
  { value: FloraFeedbackReason.Incomplete, label: 'Incomplete — missing information' },
  { value: FloraFeedbackReason.IgnoredRequest, label: "Didn't follow my request" },
  { value: FloraFeedbackReason.Formatting, label: 'Too long, too short, or badly formatted' },
  { value: FloraFeedbackReason.Outdated, label: 'Outdated information' },
  { value: FloraFeedbackReason.Other, label: 'Other' },
];

const FLORA_FEEDBACK_COMMENT_MAX_LENGTH = 10000;

type FloraFeedbackPayload = {
  chat_history_id: string;
  sentiment: FloraFeedbackSentiment;
  reasons?: FloraFeedbackReason[];
  comment?: string;
};

type FloraFeedbackResponse = {
  id: string;
  sentiment: FloraFeedbackSentiment;
  reasons: FloraFeedbackReason[];
  comment: string | null;
  flora_version: string | null;
  turn_index: number;
  metadata: Record<string, unknown>;
  metadata_created_at: string;
};

/**
 * Normalized rejection shape from the client. `status` is preserved so callers
 * can treat a 409 (already submitted for this response) as "already rated".
 */
type FloraFeedbackError = {
  status?: number;
  data?: unknown;
};

export {
  FLORA_FEEDBACK_COMMENT_MAX_LENGTH,
  FLORA_FEEDBACK_REASON_OPTIONS,
  FloraFeedbackReason,
  FloraFeedbackSentiment,
};
export type { FloraFeedbackError, FloraFeedbackPayload, FloraFeedbackResponse };
